import { Component, OnInit, Pipe, PipeTransform } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from '../../../services/admin.service';
import { ReportService } from '../../../services/report.service';
import { ChangeModalsComponent } from './change-modals/change-modals.component';
import { InfoPopupComponent } from '../view-group/popups/info-popup/info-popup.component';


export class CalendarDay {
  public date: Date;
  public title: string;
  public isPastDate: boolean;
  public isToday: boolean;
  public isCheck: boolean;
  public id: string;
  public isPublicHoliday: boolean;

  public getDateString() {
    return this.date.toISOString().split('T')[0];
  }

  constructor(d: Date, datas = []) {
    this.date = d;
    let data = datas;
    for (var i = 0; i < data.length; i++) {
      if (d.toISOString().split('T')[0] == data[i].date) {
        this.id = data[i].id;
        this.isCheck = true;
        this.isPublicHoliday = data[i].isPublicHoliday;
      }
    }
    this.isPastDate = d.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0);
    this.isToday = d.setHours(0, 0, 0, 0) == new Date().setHours(0, 0, 0, 0);
  }
}

@Pipe({
  name: 'chunk',
})
export class ChunkPipe implements PipeTransform {
  transform(calendarDaysArray: any, chunkSize: number): any {
    let calendarDays = [];
    let weekDays = [];

    calendarDaysArray.map((day, index) => {
      weekDays.push(day);
      if (++index % chunkSize === 0) {
        calendarDays.push(weekDays);
        weekDays = [];
      }
    });
    return calendarDays;
  }
}

@Component({
  selector: 'app-task-fullview-popup',
  templateUrl: './task-fullview-popup.component.html',
  styleUrls: ['./task-fullview-popup.component.css']
})

export class TaskFullviewPopupComponent implements OnInit {

  public calendar: CalendarDay[] = [];
  public monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  public displayMonth: string;
  public displayYears: number;
  private monthIndex: number = 0;
  from;
  to;
  datas;
  chibriki = false;

  constructor(private adminService: AdminService, private modalService: NgbModal, public reportService: ReportService) {

  }

  ngOnInit(): void {
    this.generateCalendarDays(this.monthIndex);
  }

  private generateCalendarDays(monthIndex: number): void {

    this.calendar = [];

    let day: Date = new Date(
      new Date().setMonth(new Date().getMonth() + monthIndex)
    );

    this.displayMonth = this.monthNames[day.getMonth()];
    this.displayYears = day.getFullYear();
    let startingDateOfCalendar = this.getStartDateForCalendar(day);
    let dateToAdd = startingDateOfCalendar;

    for (var i = 0; i < 42; i++) {
      this.calendar.push(new CalendarDay(new Date(dateToAdd), this.datas));
      dateToAdd = new Date(dateToAdd.setDate(dateToAdd.getDate() + 1));
    }

    this.from = (new Date(this.calendar[0].date.getTime() - (this.calendar[0].date.getTimezoneOffset() * 60000)).toISOString().split('T')[0]).toString();
    this.to = (new Date(this.calendar[41].date.getTime() - (this.calendar[41].date.getTimezoneOffset() * 60000)).toISOString().split('T')[0]).toString();

    if (this.chibriki) {
      this.getListWeekends(this.from, this.to);
    }

    if (!this.datas) {
      this.getListWeekends(this.from, this.to);
    }
  }

  private getStartDateForCalendar(selectedDate: Date) {
    let lastDayOfPreviousMonth = new Date(selectedDate.setDate(0));
    let startingDateOfCalendar: Date = lastDayOfPreviousMonth;
    if (startingDateOfCalendar.getDay() != 1) {
      do {
        startingDateOfCalendar = new Date(
          startingDateOfCalendar.setDate(startingDateOfCalendar.getDate() - 1)
        );
      } while (startingDateOfCalendar.getDay() != 1);
    }
    return startingDateOfCalendar;
  }

  public increaseMonth() {
    this.chibriki = true;
    this.monthIndex++;
    this.generateCalendarDays(this.monthIndex);
  }

  public decreaseMonth() {
    this.chibriki = true;
    this.datas = [];
    this.monthIndex--;
    this.generateCalendarDays(this.monthIndex);
  }

  public setCurrentMonth() {
    this.monthIndex = 0;
    this.generateCalendarDays(this.monthIndex);
  }

  getListWeekends(from, to) {
    this.adminService.getListWeekends(from, to).subscribe(
      (res: any) => {
        this.chibriki = false;
        this.datas = res.body;
        if (this.datas) {
          this.generateCalendarDays(this.monthIndex);
        }
      },
      () => {

      }
    );
  }

  popapOpen(data) {
    if (data.id) {
      this.adminService.delWeekends(data.id).subscribe(
        (res: any) => {
          this.getListWeekends(this.from, this.to);
        },
      );
    } else {
      const modalRef = this.modalService.open(InfoPopupComponent);
      modalRef.result.then((result) => {
        if (result === 'Yes') {
          this.openEdit(data, true);
        }
        if (result === 'No') {
          this.openEdit(data, false);
        }
      })
    }
  }

  openEdit(data, type) {
      let date = (new Date(data.date.getTime() - (data.date.getTimezoneOffset() * 60000)).toISOString().split('T')[0]);
      this.adminService.addWeekends(date, type).subscribe(
        (res: any) => {
          this.getListWeekends(this.from, this.to);
        },
        () => {

        }
      );
  }


  // openEdit(data) {
  //   const modalRef = this.modalService.open(ChangeModalsComponent);
  //   modalRef.componentInstance.action = data;
  //   modalRef.result.then((result) => {
  //     if (result === 'ok') {
  //       this.getListWeekends(this.from, this.to);
  //     }
  //   });
  // }
}




// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/views/task-fullview-popup/task-fullview-popup.component.ts